import { EventNames } from '@farmasiet/frontendcore-reactcomponents';
import React, { useContext, useEffect, useState } from 'react';

import { ExpectedDeliveryDateViewModel } from '../../../Purchase/Checkout/Delivery/DeliveryMethods/Common/ExpectedDelivery/ExpectedDeliveryDateViewModel.csharp';
import { DeliveryMethod } from '../../../Purchase/Checkout/Delivery/DeliveryMethods/DeliveryMethod.csharp';
import { getFor, post } from '../../API';
import { UserContext } from '../../Contexts/UserContext';
import { expectedDeliveryDate } from '../../ExpectedDeliveryDate/ExpectedDeliveryDate';
import { ExpectedDeliveryDateModal } from '../../ExpectedDeliveryDate/ExpectedDeliveryDateModal/ExpectedDeliveryDateModal';
import { PhilExpectedDeliveryDateViewWrapperProps } from './PhilExpectedDeliveryDateViewWrapper';

enum DeliveryMethodPhil {
    PorterBuddy = 'PorterBuddy',
    PostNHome = 'PostNHome',
    PostNMail = 'PostNMail',
    PostNPick = 'PostNPick',
    SfjStore = 'SfjStore',
    HeltHjem = 'HeltHjem',
    PostNPickLockers = 'PostNPickLockers',
    InstaBox = 'InstaBox',
    InstaBoxHome = 'InstaBoxHome',
    AirmeeHome = 'AirmeeHome',
    HeltHjemServicePoint = 'HeltHjemServicePoint',
    Gordon = 'Gordon'
}

const transformToDeliveryMethod = (methods: DeliveryMethodPhil[]): DeliveryMethod[] => {
    return methods.map((method) => DeliveryMethod[method as keyof typeof DeliveryMethod]);
};

export const PhilExpectedDeliveryDateModalWrapper = (props: PhilExpectedDeliveryDateViewWrapperProps) => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isInitialized, setIsInitialized] = useState<boolean>(false);
    const userContext = useContext(UserContext);

    const postalCode = expectedDeliveryDate.postalCode || userContext.user?.address?.postalCode || null;

    useEffect(() => {
        window.addEventListener(EventNames.OpenDeliveryModal, handleOpenDeliveryModal);
    }, []);

    const handleOpenDeliveryModal = ($event: CustomEventInit) => {
        const parsedDeliveryMethods = JSON.parse($event.detail.deliveryMethods || '[]') as DeliveryMethodPhil[];
        const transfromedDeliveryMethods = transformToDeliveryMethod(parsedDeliveryMethods);
        expectedDeliveryDate.setMethodsAvailableForProduct(transfromedDeliveryMethods);
        setIsModalOpen(true);
        setIsInitialized(true);
    };

    const getDeliveryMethods = async (_postalCode: string) => {
        return await getFor<ExpectedDeliveryDateViewModel[]>(`${props.getExpectedDeliveryDateUrl}?postalCode=${_postalCode}`);
    };

    const logCustomEvent = (name: string, properties?: { [key: string]: string }) => {
        post(props.logCustomEventUrl, { name, properties }).catch(() => ({}));
    };

    const closeModal = () => setIsModalOpen(false);

    return isInitialized ? (
        <ExpectedDeliveryDateModal
            deliveryInfoUrl={props.deliveryInfoPage}
            isOpen={isModalOpen}
            onClose={closeModal}
            getDeliveryMethods={getDeliveryMethods}
            initialPostalCode={postalCode}
            logoPictureProfile={props.logoPictureProfile}
            logCustomEvent={logCustomEvent}
            checkDeliveryDateOnOpen
        />
    ) : (
        <></>
    );
};
